<div class="po-loading-icon">
  <span class="po-loading-icon-bar po-loading-icon-bar-1"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-2"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-3"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-4"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-5"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-6"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-7"></span>
  <span class="po-loading-icon-bar po-loading-icon-bar-8"></span>
</div>